/**
 * Only a wake-up signal. The receiving tab must ask /admin/v1/me; a local
 * storage value is never proof of identity or permission.
 */
export const ADMIN_AUTH_CHANGE_KEY = 'blasto-admin-auth-change-v1';

export function announceAdminAuthChange(): void {
  try {
    // A new value causes a storage event in the other same-origin tabs.
    window.localStorage.setItem(ADMIN_AUTH_CHANGE_KEY, `${Date.now()}:${Math.random()}`);
  } catch {
    // Browsers that deny storage still revalidate when the admin tab focuses.
  }
}
